import Navigation from "./Navigation";
import Breadcrumbs from "./Breadcrumbs";
import Footer from "./Footer";

interface PageLayoutProps {
  children: React.ReactNode;
  showBreadcrumbs?: boolean;
}

export default function PageLayout({ children, showBreadcrumbs = true }: PageLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1 pt-32">
        {children}
      </main>
      {showBreadcrumbs && <Breadcrumbs />}
      <Footer />
    </div>
  );
}
